import { Component } from '@angular/core';
import { PIE_PANEL_IMPORTS, PiePanelComponent } from 'src/app/panels/components/pie/pie-panel/pie-panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import { PanelComponent } from '../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/pie/pie-panel/pie-panel.component.html',
  styleUrl: '../../../../panels/components/pie/pie-panel/pie-panel.component.scss',
  selector: 'app-energy-carrier-co2-pie-panel',
  imports: PIE_PANEL_IMPORTS,
})
export class EnergyCarrierCo2PiePanelComponent extends PiePanelComponent {
  public static override readonly type = PanelType.EnergyCarrierCo2Pie;
  public override title = 'CO₂ per energiedrager';
  public override icon = 'bi-cloud-fog2-fill';
  public override unit = DisplayUnit.Kg;
}
